export enum etat_seance {
    ETAT_NON_PLANIFIE,
    ETAT_PLANIFIE_AUTO,
    ETAT_PLANIFIE_MANUEL,
    ETAT_DEMISSIONE,
}
